/**
 * AuthBanner - Shows notification at top of ALL pages (dentLAB + dentCONNECT)
 *
 * TO UPDATE:
 * 1. Edit the 5 constants below (lines 24-28)
 * 2. Deploy
 *
 * COLORS: bg-red-600 (critical) | bg-amber-600 (warning) | bg-green-600 (success) | bg-blue-600 (info)
 * ICONS: AlertTriangle | Clock | Wrench | CheckCircle2 | Info
 *
 * TO HIDE: Change line 37 to `if(false) {`
 *
 * Full docs: README.md in this directory
 */

import React from "react";
import { AlertTriangle, LucideIcon } from "lucide-react";
import { isDentlabUser, isDentconnectUser } from "@/lib/utils/is-app-user";

const BANNER_TITLE = "Wartungsarbeiten - Anmeldung vorübergehend nicht möglich";
const BANNER_DESCRIPTION = "Die Anmeldung ist derzeit nicht möglich. Unser Team arbeitet an der Behebung.";
const BANNER_HINT = "";
const BANNER_ICON: LucideIcon = AlertTriangle;
const BANNER_BG_COLOR = "bg-red-600";

const IS_DENTLAB_BROKEN = false;
const IS_DENTCONNECT_BROKEN = false;

export const AuthBanner: React.FC = () => {
	const borderColor = BANNER_BG_COLOR.replace("600", "700/30");
	const Icon = BANNER_ICON;
	const isDentlab = isDentlabUser(import.meta.env);
	const isDentconnect = isDentconnectUser(import.meta.env);

	const showBanner = (isDentlab && IS_DENTLAB_BROKEN) || (isDentconnect && IS_DENTCONNECT_BROKEN);

	if (!showBanner) {
		return null;
	}
	return (
		<div className={`${BANNER_BG_COLOR} border-b-2 border-${borderColor} w-full shadow-sm`}>
			<div className="max-w-7xl mx-auto px-6 py-4 flex flex-row items-center gap-4">
				{Icon && <Icon className="h-6 w-6 text-white flex-shrink-0" />}
				<div className="flex flex-col gap-1.5 flex-1 min-w-0">
					<h2 className="text-base font-semibold leading-tight text-white">
						{BANNER_TITLE}
					</h2>
					<p className="text-sm text-white/90 leading-snug">
						{BANNER_DESCRIPTION}
					</p>
					{BANNER_HINT && (
						<p className="text-xs text-white/75 leading-snug mt-0.5">
							{BANNER_HINT}
						</p>
					)}
				</div>
			</div>
		</div>
	);
};
